<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelLocalidade"
    :multiple="isMulti"
    :taggable="isTagabble"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="isAllowEmpty"
    :preselectFirst="preselectFirst"
    :loading="isLoading"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    :class="isMulti ? 'multiselect-primary' : ''"
    inputContainerClass="d-flex"
    :hide-selected="isHideSelected"
    :close-on-select="isCloseOnSelect"
  >
    <template slot="tag" slot-scope="{ option, remove }">
      <span class="multiselect__tag">
        <span v-if="option">{{ option.numero }} - {{ option.nome }}</span>
        <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="remove(option)"></i>
      </span>
    </template>
    <template slot="noResult">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: {
    nameField: {},
    empresaSelected: {},
    localidadesSelected: {},
    centroCustoSelected: {},
    preselectFirst: { type: Boolean, default: false },
    isRequired: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    emptyLabel: { type: String, default: null },
    siteSelected: {},
    includeAll: { type: Boolean, default: false },
    filtrarLocalidadesJaVinculadas: { type: Boolean, default: false },
    filtrarJaVincPerfilComp: { type: Boolean, default: false },
    idEmpresasPerfilComp: { type: Array, default: () => [] },
    idPerfilCompeticao: {},
    isObject: { type: Boolean, default: false },
    aditionalColumns: {},
    isMulti: { type: Boolean, default: false },
    isTagabble: { type: Boolean, default: false },
    isAllowEmpty: { type: Boolean, default: false },
    isHideSelected: { type: Boolean, default: false },
    isCloseOnSelect: { type: Boolean, default: true },
    setSelectAll: { type: Boolean, default: false },
    isOrigem: { type: Boolean, default: false },
    setRemoveAll: { type: Boolean, default: false },
    requireBrand: { type: Boolean, default: false },
    brandSelected: {}
  },

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },
  methods: {
    selectAll() {
      let item = [];
      this.selected = [];
      this.options.forEach((el) => {
        this.selected.push(el);
        item.push(el.id);
      });
      this.$emit('input', this.selected);
      this.$emit('selectChange', 'id_localidade', item);
    },
    removeAll() {
      this.selected = [];
      this.$emit('input', this.selected);
      this.$emit('selectChange', 'id_localidade', this.selected);
    },
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_localidade', null);
        return;
      }
      if (this.isMulti) {
        let arr = new Array();
        e.forEach((el) => {
          arr.push(el.id);
        });
        this.$emit('selectChange', 'id_localidade', arr);
      } else {
        this.isObject
          ? this.$emit('selectChange', 'id_localidade', e)
          : this.$emit('selectChange', 'id_localidade', e.id);
      }
      this.$emit('focus');
    },

    labelLocalidade({ nome, numero }) {
      return numero ? `${numero} - ${nome}` : `${nome}`;
    },

    setValue(value) {
      if (value) {
        if (this.isMulti) {
          this.selected = [];
          value.forEach((el) => {
            const elem = this.options.find((option) => option.id === el);
            if (elem) this.selected.push(elem);
          });
        } else {
          this.selected = this.options.find((option) => option.id === parseInt(value));
        }
      } else {
        if (this.includeAll) {
          this.selected = this.options.find((option) => option.id === null);
        } else {
          this.isMulti ? (this.selected = []) : (this.selected = '');
        }
      }

      this.preselectFirst && !this.isMulti && !this.selected ? this.preselectFirstCheck() : null;
      this.$emit('input', this.selected);
    },

    preselectFirstCheck() {
      this.selected = this.options[0];
      this.$emit('selectChange', 'id_localidade', this.options[0].id);
    },

    async setOptions(filtros) {
      let filtro = `business_logic.localidade.excluido=false and business_logic.localidade.bloqueado=false and business_logic.localidade.ativo=true `;

      this.filtrarJaVincPerfilComp
        ? (filtro += `and id_empresa in (${this.idEmpresasPerfilComp.toString()}) `)
        : (filtro += `and id_empresa=${this.$store.state.user.info.id_empresa} `);

      if (filtros && filtros.siteIdLocalidades) {
        filtro += `and business_logic.localidade.id in (${filtros.siteIdLocalidades})`;
      }

      if (filtros && filtros.localidadesIds) {
        filtro += `and business_logic.localidade.id in (${filtros.localidadesIds.toString()})`;
      }

      if (filtros && filtros.empresaId) {
        filtro = `id_empresa=${this.isObject && filtros.empresaId.id ? filtros.empresaId.id : filtros.empresaId} `;
      }

      if (!(filtros && filtros.empresaId) && this.$store.state.user.info.localidades) {
        filtro += `and business_logic.localidade.id in (${this.$store.state.user.info.localidades})`;
      }

      if (this.requireBrand) {
        const idsByBrand = await this.getLocsIdByBrand(this.brandSelected);
        if (idsByBrand) {
          filtro += `and business_logic.localidade.id in (${idsByBrand})`;
        } else {
          return;
        }
      }

      let colunas_adicionais = '';

      if (this.aditionalColumns && this.aditionalColumns.length) {
        colunas_adicionais += ` , ${this.aditionalColumns.toString()}`;
      }
      if (this.filtrarLocalidadesJaVinculadas == true) {
        filtro +=
          'and business_logic.localidade.id not in (select distinct ((json_array_elements(id_localidades)::text)::integer) from business_logic.localidade_web) ';
      }
      if (this.nameField && this.filtrarLocalidadesJaVinculadas == true) {
        filtro += `union select id, numero, nome from business_logic.localidade where id=${this.nameField.toString()}`;
      }

      if (this.filtrarJaVincPerfilComp == true) {
        if (this.idPerfilCompeticao) {
          filtro += `and ((id_perfil_competicao=${this.idPerfilCompeticao}) or (id_perfil_competicao is null)) `;
        } else {
          filtro += 'and id_perfil_competicao is null ';
        }
      }
      if (this.isOrigem) {
        filtro += ` and (business_logic.localidade.configuracao#>>'{premiosOrigem,ativo}')::boolean = true `;
      }

      if (filtros && filtros.centroCustoId) {
        filtro += `and id_centro_de_custo=${
          this.isObject && filtros.centroCustoId.id ? filtros.centroCustoId.id : filtros.centroCustoId
        }`;
      }

      this.isLoading = true;
      this.$atenaList
        .getLocalidades({
          columns: ` id, numero, nome ${colunas_adicionais} `,
          filter: filtro,
          order: 'numero',
          limit: -1
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }

          this.options = this.options.concat(res.data);
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    async getLocsIdByBrand(id_brand) {
      try {
        const brand = await this.$atenaList.getCommon('brand_sysa', {
          columns: 'id_site',
          filter: `brand.id = ${id_brand}`
        });

        const site = await this.$atenaList.getSites({
          columns: 'id_localidades',
          filter: `localidade_web.id=${brand.data[0].id_site}`
        });

        if (site?.data[0]?.id_localidades.length) return JSON.parse(site?.data[0]?.id_localidades).toString();

        return false;
      } catch (error) {
        console.log(error);
        return false;
      }
    }
  },
  created() {
    if (this.siteSelected && this.preselectFirst == true) {
      this.setOptions({ siteIdLocalidade: this.nameField });
      return;
    }
    if (!this.requireBrand) {
      this.setOptions();
    }
  },
  watch: {
    nameField: function (newVal) {
      this.setValue(newVal);
    },
    empresaSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions({ empresaId: newVal, centroCustoId: null });
      }
    },
    centroCustoSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions({ empresaId: this.empresaSelected, centroCustoId: newVal });
      }
    },
    siteSelected(newVal) {
      const id_localidades = newVal?.id_localidades;
      const valoresSemColchetes = id_localidades ? id_localidades.substring(1, id_localidades.length - 1) : null;
      this.setOptions({ siteIdLocalidades: valoresSemColchetes });
    },
    localidadesSelected(newVal) {
      const localidadesIds = JSON.parse(newVal.id_localidades).toString();
      this.setOptions({ localidadesIds });
    },
    setSelectAll: function (newVal) {
      if (newVal === true) {
        this.selectAll();
      }
    },
    setRemoveAll: function (newVal) {
      if (newVal === true) {
        this.removeAll();
      }
    },
    brandSelected: function (newVal) {
      if (newVal) {
        this.setOptions();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.multiselect-primary {
  .multiselect__tags {
    display: flex !important;
  }
}
</style>
